import { Component, OnInit } from '@angular/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { ChartType, ChartDataset } from 'chart.js';
import { concat } from 'rxjs';

@Component({
  selector: 'app-automation-tool',
  templateUrl: './automation-tool.component.html',
  styleUrls: ['./automation-tool.component.scss']
})
export class AutomationToolComponent implements OnInit {
  noOfRecords: any = "20";
  reportData: any;
  details: any = [];
  showDetails = false;
  progressbar = false;
  afterTest = false;
  hide1 = false;
  showArray: any = []
  public chartColors: any[] = [
    { // first color
      backgroundColor: 'rgba(2, 4, 179, 0.92)',
      borderColor: 'rgba(2, 4, 179, 0.92)',
      pointBackgroundColor: 'rgba(2, 4, 179, 0.92)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(2, 4, 179, 0.92)'
    },
    { // second color
      backgroundColor: 'rgba(24, 184, 9, 0.8)',
      borderColor: 'rgba(24, 184, 9, 0.8)',
      pointBackgroundColor: 'rgba(24, 184, 9, 0.8)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(24, 184, 9, 0.8)'
    },
    { // third color
      backgroundColor: 'rgba(236, 14, 14, 0.8)',
      borderColor: 'rgba(236, 14, 14, 0.8)',
      pointBackgroundColor: 'rgba(236, 14, 14, 0.8)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(236, 14, 14, 0.8)'
    },
    { // forth color
      backgroundColor: 'rgba(255, 165, 0)',
      borderColor: 'rgba(255, 165, 0)',
      pointBackgroundColor: 'rgba(255, 165, 0)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(255, 165, 0)'
    }];
  public barChartOptions: any = {
    responsive: false,
    scales: {
      y: {
        axis: 'y',
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 20
        }
      }
    },
    plugins: {
      tooltip: {
        titleFont: {
          size: 0
        }
      }
    },
    maintainAspectRatio: true
  };
  public barChartLabels: string[] = [''];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];

  public barChartData: ChartDataset<'bar'>[] = [];
  constructor(private service: ApifirstService) { }

  ngOnInit(): void {
  }

  updateRecord(e: any) {
    this.noOfRecords = e.target.value;
    console.log(this.noOfRecords, "records")
  }

  getRecords() {
    this.barChartData = [];
    this.progressbar = true;
    this.afterTest = false;
    if(this.noOfRecords == "20" || this.noOfRecords == "100"){
    this.service.getReports(this.noOfRecords).subscribe(data => {
      this.reportData = data;
      console.log(this.reportData, "reports")
      this.details = this.reportData.details;
      console.log(this.details, "details")
      // let chartData=[];

      this.barChartData.push({
        data: [this.reportData.totalRecords],
        label: 'Total',
        backgroundColor: 'rgba(2, 4, 179, 0.92)',
        borderColor: 'rgba(2, 4, 179, 0.92)',
        hoverBackgroundColor: 'rgba(2, 4, 179, 0.92)',
        hoverBorderColor: 'rgba(2, 4, 179, 0.92)'

      });

      this.barChartData.push({
        data: [this.reportData.passed],
        label: 'Passed',
        backgroundColor: 'rgba(24, 184, 9, 0.8)',
        borderColor: 'rgba(24, 184, 9, 0.8)',
        hoverBackgroundColor: 'rgba(24, 184, 9, 0.8)',
        hoverBorderColor: 'rgba(24, 184, 9, 0.8)'
      });


      this.barChartData.push({
        data: [this.reportData.failed],
        label: 'Failed',
        backgroundColor: 'rgba(236, 14, 14, 0.8)',
        borderColor: 'rgba(236, 14, 14, 0.8)',
        hoverBackgroundColor: 'rgba(236, 14, 14, 0.8)',
        hoverBorderColor: 'rgba(236, 14, 14, 0.8)'
      });

      this.barChartData.push({
        data: [this.reportData.invalidSession],
        label: 'Invalid Session',
        backgroundColor: 'rgba(255, 165, 0)',
        borderColor: 'rgba(255, 165, 0)',
        hoverBackgroundColor: 'rgba(255, 165, 0)',
        hoverBorderColor: 'rgba(255, 165, 0)'
      });

      console.log(this.barChartData)
      if (this.noOfRecords == "20") {
        this.barChartOptions = {
          responsive: false,
          scales: {
            y: {
              beginAtZero: true,
              max: this.reportData.totalRecords,
              ticks: {
                stepSize: 5
              }
            }
          },
          plugins: {
            tooltip: {
              titleFont: {
                size: 0
              }
            }
          },
          maintainAspectRatio: true
        }
      }
      else if (this.noOfRecords == "100") {
        this.barChartOptions = {
          responsive: false,
          scales: {
            y: {
              beginAtZero: true,
              max: this.reportData.totalRecords,
              ticks: {
                stepSize: 20
              }
            }
          },
          plugins: {
            tooltip: {
              titleFont: {
                size: 0
              }
            }
          },
          maintainAspectRatio: true
        }
      }
    },
      error => {
        this.progressbar = false;
      },()=>{
        // this part is executed after completing Api call success
        this.afterTest = true;
        this.progressbar = false;
      })
    }

// Records above 500
if(this.noOfRecords == "500" || this.noOfRecords == "1000" || this.noOfRecords == "10000"){
  this.details = [];
    let calls = [];
    let totalReportdata = 0;
    let totalPassedData = 0;
    let totalFailedData = 0;
    let totalInvalidSessionData = 0;
        
        
for (let i = 0; i <= this.noOfRecords / 100 - 1; i++) {
  calls.push(this.service.getLargeReports(this.noOfRecords,i,100));
}
concat(...calls).subscribe((data)=>{
  totalReportdata += data["totalRecords"]
  totalPassedData += data["passed"]
  totalFailedData += data["failed"]
  totalInvalidSessionData += data["invalidSession"]
  
  this.reportData = data;
      // this.details = this.reportData.details;
      this.reportData.details.map((data: any)=>{
        this.details.push(data)
      })
      // let chartData=[];

      console.log(this.barChartData)
    },((error)=>{
      this.progressbar = false;
    }),()=>{
      // this part is executed after completing all Api calls success
      this.afterTest = true;
      this.progressbar = false;
      this.barChartData.push({
        data: [totalReportdata],
        label: 'Total',
        backgroundColor: 'rgba(2, 4, 179, 0.92)',
        borderColor: 'rgba(2, 4, 179, 0.92)',
        hoverBackgroundColor: 'rgba(2, 4, 179, 0.92)',
        hoverBorderColor: 'rgba(2, 4, 179, 0.92)'
    
      });
    
      this.barChartData.push({
        data: [totalPassedData],
        label: 'Passed',
        backgroundColor: 'rgba(24, 184, 9, 0.8)',
        borderColor: 'rgba(24, 184, 9, 0.8)',
        hoverBackgroundColor: 'rgba(24, 184, 9, 0.8)',
        hoverBorderColor: 'rgba(24, 184, 9, 0.8)'
      });
    
    
      this.barChartData.push({
        data: [totalFailedData],
        label: 'Failed',
        backgroundColor: 'rgba(236, 14, 14, 0.8)',
        borderColor: 'rgba(236, 14, 14, 0.8)',
        hoverBackgroundColor: 'rgba(236, 14, 14, 0.8)',
        hoverBorderColor: 'rgba(236, 14, 14, 0.8)'
      });
    
      this.barChartData.push({
        data: [totalInvalidSessionData],
        label: 'Invalid Session',
        backgroundColor: 'rgba(255, 165, 0)',
        borderColor: 'rgba(255, 165, 0)',
        hoverBackgroundColor: 'rgba(255, 165, 0)',
        hoverBorderColor: 'rgba(255, 165, 0)'
      });
    
      if (this.noOfRecords == "500") {
        this.barChartOptions = {
          responsive: false,
          scales: {
            y: {
              beginAtZero: true,
              max: totalReportdata,
              ticks: {
                stepSize: 100
              }
            }
          },
          plugins: {
            tooltip: {
              titleFont: {
                size: 0
              }
            }
          },
          maintainAspectRatio: true
        }
      }
      else if (this.noOfRecords == "1000") {
        this.barChartOptions = {
          responsive: false,
          scales: {
            y: {
              beginAtZero: true,
              max: totalReportdata,
              ticks: {
                stepSize: 200
              }
            }
          },
          plugins: {
            tooltip: {
              titleFont: {
                size: 0
              }
            }
          },
          maintainAspectRatio: true
        }
      }
      else if (this.noOfRecords == "10000") {
        this.barChartOptions = {
          responsive: false,
          scales: {
            y: {
              beginAtZero: true,
              max: totalReportdata,
              ticks: {
                stepSize: 2000
              }
            }
          },
          plugins: {
            tooltip: {
              titleFont: {
                size: 0
              }
            },
          },
          maintainAspectRatio: true
        }
      }
    })
  }
    //this.reportData=this.service.getReports("20");

  }
  onSelectgroup(index: any) {
    for (let d in this.details) {
      if (d == index) {
        this.showArray[index] = false;
      }
    }
    console.log(this.hide1)
  }
  onSelectgroup1(index: any) {
    for (let d in this.details) {
      if (d == index) {
        this.showArray[index] = true;
      }
      else {
        this.showArray[d] = false
      }
    }
  }
}
